<template>
  <drag-dialog
    title="移动到"
    :width="400"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="common-tree-box">
      <el-tree
        class="dialog-tree-primary"
        ref="moveTree"
        :data="data"
        :props="defaultProps"
        node-key="nodeId"
        highlight-current
        :expand-on-click-node="false"
        :default-expand-all="true"
        @node-click="handleNodeClick">
        <span
          slot-scope="{ node, data }"
          class="tree-text">
          <div class="tree-node">
            <icon-svg
              v-if="data.nodeType === 1"
              class="icon"
              icon-class="ic-ico_folder" />
            <icon-svg
              v-if="data.nodeType === 2"
              class="icon"
              icon-class="ic-ico-group" />
            <span class="tree-node-text" :title="node.label">{{ node.label }}</span>
          </div>
        </span>
      </el-tree>
    </div>
  </drag-dialog>
</template>

<script>
import dragDialog from '@/components/CustomDragDialog.vue'
export default {
  data() {
    return {
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      }
    }
  },
  props: {
    visible: Boolean,
    data: Array,
    nodeClick: Function,
    submitMove: Function,
    closeDialog: Function
  },
  components: {
    dragDialog
  },
  methods: {
    handleNodeClick(data, node) {
      this.nodeClick(data, node)
    },
    submit() {
      this.submitMove()
    },
    cancel() {
      this.closeDialog()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.common-tree-box {
  color: var(--default-color);
  max-height: 500px;
  overflow: auto;

  .tree-text {
    width: calc(100% - 32px);

    .tree-node {
      display: flex;
      align-items: center;
      width: 100%;

      &-text{
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .icon {
    color: var(--icon-color);
    font-size: 16px;
    margin-right: 10px;
    vertical-align: middle;
  }
}
</style>
